export function formatInvoicePaymentMethod(
  paymentMethod?: number | null | string,
  country?: number | null | string
): string {
  let methodValue: number | null | undefined;
  if (typeof paymentMethod === "string") {
    const parsed = parseInt(paymentMethod, 10);
    methodValue = Number.isNaN(parsed) ? null : parsed;
  } else {
    methodValue = paymentMethod;
  }

  if (methodValue === null || methodValue === undefined) {
    return "";
  }

  let countryValue: number | null | undefined;
  if (typeof country === "string") {
    const parsed = parseInt(country, 10);
    countryValue = Number.isNaN(parsed) ? null : parsed;
  } else {
    countryValue = country;
  }

  if (methodValue === 1) {
    return "Pay Now (TempStars' Payment Processor)";
  }
  if (methodValue === 2) {
    return countryValue === 0 ? "Cheque" : "Check";
  }
  if (methodValue === 3) {
    return "Paypal/etransfer";
  }
  if (methodValue === 4) {
    return "Direct Deposit";
  }
  return `Unknown (${methodValue})`;
}
